import React from 'react'
import style from '../startedsoon/startsoon.module.css'

function Sankalpbysunil() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/A4AED749-4623-4016-A85A-2E0B6CB73F5F_plus.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
          <p>HINDI    UPSC NDA</p>
          <h4>Sankalp : Complete Course on Geography for NDA I - 2021</h4> 
          <p>Ended on 23 Jan 2022 40 lessons</p> 
          <p>Sunil Kumar Gupta</p>  
        </div>
    </div>        
  )
}
export default Sankalpbysunil;